import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'
import { FlightsClassTypes } from 'constants/flight'
import { EmptyArray } from 'lib/array/arrayUtils'
import { useContext, useEffect } from 'react'
import GeoContext from 'contexts/geoContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchFlights } from 'actions/FlightActions'
import { getFlightSearchKey } from 'lib/flights/flightUtils'
import useStableObjectReference from 'hooks/useStableObjectReference'
import { CHARTER } from 'constants/provider'

export default function useAllCharterFlightJourneys({
  charterBundleRoute,
  occupancies = EmptyArray,
  fareClass,
  disabled,
}: {
  charterBundleRoute?: App.CharterBundleRoute
  occupancies: Array<App.Occupants>
  fareClass: FlightsClassTypes
  disabled?: boolean
}) {
  const routeInfo = charterBundleRoute ? CHARTER_FLIGHT_DETAILS[charterBundleRoute] : undefined
  const { currentCurrency } = useContext(GeoContext)

  const flightSearchArgs = useStableObjectReference<Parameters<typeof fetchFlights>[0] | undefined>(
    routeInfo ? {
      itinerary: [{
        departureAirport: routeInfo.originAirport.airportCode ?? '',
        arrivalAirport: routeInfo.destinationAirport.airportCode ?? '',
        departureDate: routeInfo.dateRange.min,
      },
      {
        departureAirport: routeInfo.destinationAirport.airportCode ?? '',
        arrivalAirport: routeInfo.originAirport.airportCode ?? '',
        departureDate: routeInfo.dateRange.max,
      }],
      occupancies,
      fareClass,
      source: CHARTER,
      currency: currentCurrency,
    } : undefined,
  )

  const key = flightSearchArgs && getFlightSearchKey(flightSearchArgs)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!disabled && flightSearchArgs) {
      dispatch(fetchFlights(flightSearchArgs))
    }
  }, [disabled, flightSearchArgs, dispatch])

  const flightsV2 = useAppSelector(state => key ? state.flights.searchV2Flights[key] : undefined)

  return flightsV2
}
